import React from "react";
import PropTypes from "prop-types";
import { Autocomplete, Box, Button, Grid, MenuItem, TextField, Typography } from "@mui/material";
import { Computer, Refresh } from "@mui/icons-material";
export default function HeaderCerberus({
  onRefresh,
  loading,
  filtros,
  onFiltroChange,
  onClearFilters,
  ipsUnicas,
}) {
  return (
    <Box sx={{ bgcolor: "#fff", border: "1px solid #dce5ed", borderRadius: 3, overflow: "hidden" }}>
      <Box
        sx={{
          bgcolor: "#193d50",
          p: 2.5,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          color: "#fff",
        }}
      >
        <Computer />
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: "#fff" }}>
            Cerberus
          </Typography>
          <Typography sx={{ fontSize: 13, color: "#d6e5ee" }}>
            Fuentes de logs y visor en tiempo real
          </Typography>
        </Box>
        <Button
          onClick={onRefresh}
          disabled={loading}
          startIcon={<Refresh />}
          sx={{ "&&": { color: "#fff", border: "1px solid #8da9bd" } }}
        >
          Actualizar
        </Button>
      </Box>
      <Grid
        container
        spacing={2}
        sx={{
          p: 2.5,
          "& .MuiInputBase-root": { minHeight: 52, fontSize: 14, color: "#243f54" },
          "& .MuiInputLabel-root": { color: "#506a80" },
        }}
      >
        <Grid item xs={12} md={5}>
          <TextField
            fullWidth
            label="Buscar nombre, host, URL o ID"
            value={filtros.busqueda}
            onChange={(e) => onFiltroChange("busqueda", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            select
            fullWidth
            label="Estado del registro"
            value={filtros.status}
            onChange={(e) => onFiltroChange("status", e.target.value)}
          >
            {[
              ["todos", "Todos"],
              ["activos", "Activos"],
              ["inactivos", "Inactivos"],
              ["eliminados", "Eliminados"],
              ["desconocidos", "Sin información"],
            ].map(([value, label]) => (
              <MenuItem key={value} value={value}>
                {label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Autocomplete
            options={ipsUnicas}
            value={filtros.ip === "todos" ? null : filtros.ip}
            onChange={(_, value) => onFiltroChange("ip", value || "todos")}
            renderInput={(params) => (
              <TextField {...params} label="Host / IP" placeholder="Todos los hosts" />
            )}
          />
        </Grid>
        <Grid item xs={12} md={1} sx={{ display: "flex", alignItems: "center" }}>
          <Button onClick={onClearFilters} sx={{ "&&": { color: "#245e89" } }}>
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
HeaderCerberus.propTypes = {
  onRefresh: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  filtros: PropTypes.object.isRequired,
  onFiltroChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  ipsUnicas: PropTypes.array.isRequired,
};
